<template>
  <div class="fields fields-no-select">
    <div class="error input-error" v-if="hasError">{{currentErrorMessage}}</div>
    <div class="input text-input fields" @click="focusRef" :class="hasValue">
      <input type="text"
             :class="inputClass"
             class="input-finder counters"
             ref="input"
             readonly
             v-on:input="updateValue($event.target.value)"
             v-on:keydown="handleKeyDown"
             v-on:keypress="handleKeyPress"
             v-model="content"
      />
      <div class="icon">
        <img :src="icon">
      </div>
      <div class="text">
        <div class="title" :class='{noDesc: description === ""}' >{{title}}</div>
        <div class="description" v-if='description !== ""'>{{description}}</div>
      </div>
      <div class="count">
        <div class="minus" @click="minusCount()" :class="{ disabled: this.count === this.min }">
          <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
               x="0px" y="0px"
               viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
              <path d="M256,0C114.844,0,0,114.844,0,256s114.844,256,256,256s256-114.844,256-256S397.156,0,256,0z M405.333,266.667
              c0,5.896-4.771,10.667-10.667,10.667H117.333c-5.896,0-10.667-4.771-10.667-10.667v-21.333c0-5.896,4.771-10.667,10.667-10.667
              h277.333c5.896,0,10.667,4.771,10.667,10.667V266.667z"/>
          </svg>
        </div>
        <div class="total" >{{count}}</div>
        <div class="plus" @click="plusCount()" :class="{ disabled: this.count === this.max }">
          <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
               x="0px" y="0px"
               viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
              <path d="M256,0C114.844,0,0,114.844,0,256s114.844,256,256,256s256-114.844,256-256S397.156,0,256,0z M405.333,266.667
                c0,5.896-4.771,10.667-10.667,10.667H277.333v117.333c0,5.896-4.771,10.667-10.667,10.667h-21.333
                c-5.896,0-10.667-4.771-10.667-10.667V277.333H117.333c-5.896,0-10.667-4.771-10.667-10.667v-21.333
                c0-5.896,4.771-10.667,10.667-10.667h117.333V117.333c0-5.896,4.771-10.667,10.667-10.667h21.333
                c5.896,0,10.667,4.771,10.667,10.667v117.333h117.333c5.896,0,10.667,4.771,10.667,10.667V266.667z"/>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    hasValue,
    initializable,
    withErrors,
    withEventDispatcher,
    withIcon,
    withPlaceholder
  } from "./mixins/input.mixin";

  export default {
    name: "number-input",
    mixins: [hasValue('content'), withErrors, withIcon, withPlaceholder, withEventDispatcher, initializable],
    props: {
      title: String,
      description: {
        type: String,
        default: ""
      },
      icon: String,
      min: Number,
      max: Number,
      default: {
        type: Number,
        default: 0
      },
      value: Number
    },
    data() {
      return {
        count: this.default
      }
    },
    mounted() {
      this.updateValue(this.default);
    },
    methods: {
      minusCount() {
        if (this.count <= this.min) {
        } else {
          this.count--;
          this.updateValue(this.count);
        }
      },
      plusCount() {
        if (this.count >= this.max) {
        } else {
          this.count++;
          this.updateValue(this.count);
        }

      },
      focusRef() {
        this.$refs.input.focus();
        this.updateValue(this.content);
      },
      _computeErrors() {
        if ((typeof this.computeErrors === 'function')) {
          this.computeErrors();
        }
        this.$emit('compute-errors', this.content);
      },
      updateValue(value) {
        this.content = value;
        this.$emit('input', value);
        if (this.useDynamicErrors) {
          this._computeErrors();
          return;
        }
        if (this.usePseudoDynamicErrors && this.hasError) {
          this._computeErrors();
        }
      }
    },
  }
</script>

<style scoped>
.noDesc {
  margin: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/number-input.vue